import React, { useState, useEffect } from "react";

// import image1 from "./Untitled design (2)/2.png";
import image2 from "../images/IMG_20230914_141154.jpg";
// import image3 from "./Untitled design (2)/1.png";
import image4 from "./sliderimage/WhatsApp Image 2025-07-30 at 09.40.20 (1).jpeg";
import image5 from "../images/IMG_1550 (FILEminimizer).JPG"
import image7 from "./sliderimage/WhatsApp Image 2025-05-24 at 10.50.44.jpeg"
import image6 from "../images/IMG_1634 (FILEminimizer).JPG"

import "./slider.css";

const Slider = () => {

  const images = [image2,image4,image5,image6,image7];

 
  const [currentIndex, setCurrentIndex] = useState(0);


  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  
  useEffect(() => {
    const intervalId = setInterval(nextImage, 2000); 
    return () => clearInterval(intervalId);
  }, []); 

  return (
  
    <div className="slider-container">
      <div className="slider">
        <div className="image-container">
          <img
            src={images[currentIndex]}
            alt="Slider Image"
            className="slider-image"
          />
          
        </div>
        <div className="slider-controls">
          <button onClick={prevImage} className="prev-btn">
            &#10094;
          </button>
          <button onClick={nextImage} className="next-btn">
            &#10095;
          </button>
        </div>
      </div>
    </div>
   
  );
};

export default Slider;
